'use strict' /* eslint-disable no-console, no-unused-vars */;

import format from './../../../money-format';

import actions from './actions.js';

import { FETCH_CART_DATA } from './mutations';
import { UPDATE_CART_QUANTITY } from './mutations';
// import { DELETE_CART_ITEM } from './mutations';
import { POST_CART_ITEM } from './mutations';
// import { REMOVE_CART_ITEM } from './mutations';
// import { RECALCULATE_TOTALS } from './mutations';
import { UPDATE_ITEM_PRICE } from './mutations';
import { UPDATE_ITEM_LOADED_COUNT } from './mutations';
import { GET_PRODUCT_INFO } from './mutations';
// import { SET_PRODUCT_PRICES } from './mutations';
import { FETCH_REFRESHED_CART_DATA } from './mutations';
import { FETCH_RELATED_CART_ITEMS } from './mutations';
import { UPDATE_AFTER_ADD_OR_DELETE } from './mutations';
import { SET_SUGGESTED_PRODUCT_PRICES } from './mutations';
import { ADD_ITEM_NOTIFICATION } from './mutations';
import { FETCH_ITEM_NOTIFICATIONS } from './mutations';

const state = {
  // 'currentView': 'inital-value'
  API_ENDPOINT: '',
  API_NOTIFICATIONS_ENDPOINT: '',
  Items: [],
  DisplayProducts: false,
  HasAbbottProduct: false,
  HasDownloadProduct: false,
  HasPrintableProduct: false,
  HasViewableProduct: false,
  IsAbbottPurchased: false,
  SubTotal: '',
  TotalProducts: 0,
  AllProductVariantIds: [],
  allProductsLoaded: 0,
  SuggestedProducts: [],
  CommonTags: [],
  MiniCartOpen: false,
  Notifications: [],
};

const helpers = {
  isOutOfStock(cartItem) {
    const availableStock = cartItem.StockQuantity;
    const outOfStock = cartItem.OutOfStock;
    const isInventoryManaged = cartItem.ManageInventoryMethodId;

    // console.log({availableStock});
    const isUk = window.env.ACTIVE_DOMAIN == 'domain_uk' ? true : false;

    // this means it's either print on demand or digital,
    // since they don't manage that inventory
    // OR it's the uk and they don't care whether it's out of stock
    if (isInventoryManaged == 0 || isUk) {
      return false;
    }

    return availableStock <= 0 && outOfStock ? true : false;
  },
};

const getters = {
  totalItemsInCart: state => {
    const total = state.TotalProducts;
    return `${total} items`;
  },

  cartPriceTotal: state => {
    return state.SubTotal;
  },

  getItemPrice: () => price => {
    return format(price);
  },

  formattedCommonTags: state => state.CommonTags.slice(0, 2).join(', '),

  reversedItems(state) {
    return state.Items.slice().reverse();
  },

  hasItemsOutOfStock: state => {
    const anyItemOutOfStock = state.Items.some(item => {
      return helpers.isOutOfStock(item);
      // return isOutOfStock;
    });

    return anyItemOutOfStock;
  },
};

const mutations = {
  setEndpoint(state) {
    state.API_ENDPOINT = `${window.env.ZOHRAB_API_DOMAIN_CLIENT}/api/v1/cart`;
    state.PRICES_ENDPOINT = `${window.env
      .API_DOMAIN_CLIENT}/api/v1/products/prices`;
    state.SEARCH_ENDPOINT = '/api/v1/search?tag=';
    state.API_NOTIFICATIONS_ENDPOINT = `${window.env
      .ZOHRAB_API_DOMAIN_CLIENT}/api/v1/notifications`;
  },

  toggleMiniCart(store, payload) {
    state.MiniCartOpen = payload;
  },

  /*
	* Fired in response to theH_CART_DATA action on
	* mount for the mini-cart, which is everywhere.
	*
	* Sets initial state.
	*/
  [FETCH_CART_DATA](state, { payload }) {
    let cartData = Object.assign({}, payload);
    // console.log(cartData);
    state.DisplayProducts = cartData.DisplayProducts;
    state.HasAbbottProduct = cartData.HasAbbottProduct;
    state.HasDownloadProduct = cartData.HasDownloadProduct;
    state.HasPrintableProduct = cartData.HasPrintableProduct;
    state.HasViewableProduct = cartData.HasViewableProduct;
    state.IsAbbottPurchased = cartData.IsAbbottPurchase;
    state.SubTotal = cartData.SubTotal;
    state.TotalProducts = cartData.TotalProducts;
    state.Tags = [];

    // set initial state for Price, which we don't get
    // out of the box. We need to do this so that
    // the property is reactive once we set it
    // on the next API call.
    const stateItems = [];
    let tags = [];

    // create an array of tags, so that we can use it later
    // to generate a list of suggested items
    cartData.Items.forEach((item, index) => {
      tags = [...tags, ...item.Tags];
      if (!item.hasOwnProperty('Price')) {
        item.Price = null;
      }
    });
    state.Tags = [...tags, ...tags];
    // console.log(tags);
    state.Items = [...cartData.Items];

    // create array of ProductIds in order to retieve price
    // information later on
    const allIds = state.Items.map(item => item.ProductId);
    state.AllProductIds = [...allIds];
  },

  /*
	* deprecated - Dec. 11, 2017.
	*
	* called by each item in the cart to set its price, which is
	* not provided by the cart API at present (Nov. 24, 2017)
	*
	* @param obj - destructured as {data} (from a GET request to the product API)
	*				and {productInfo} from the components local state.
	*/
  [GET_PRODUCT_INFO](state, { payload }) {
    // console.log(payload.data);
    const currentVariation = payload.data.ProductVariantModels.find(
      item => item.Id == payload.productInfo.ProductVariantId
    );
    const variationPrice = currentVariation.ProductVariantPrice.Price;
    const variationName = currentVariation.Name;
    const IsAbbottVariant = currentVariation.IsDownloadble;
    const IsDownloadble = currentVariation.IsDownloadble;
    const Image = payload.data.DefaultImageModel;
    const tags = payload.data.Tags;
    state.Tags = [...tags];

    state.Items.forEach((item, index) => {
      if (item.ProductVariantId == payload.productInfo.ProductVariantId) {
        // item.Price = variationPrice;
        state.Items[index].Price = variationPrice;
        // item.Name = variationName;
        state.Items[index].Name = variationName;
        state.Items[index].Img = {
          AlternateText:
            Image.AlternateText !== null ? Image.AlternateText : '',
          Id: Image.Id !== null ? Image.Id : '',
          ImageUrl: Image.ImageUrl !== null ? Image.ImageUrl : '',
          Title: Image.Title !== null ? Image.Title : '',
        };
        state.Items[index].IsAbbottVariant = IsAbbottVariant;
        state.Items[index].IsDownloadble = IsDownloadble;
      }
    });

    // update item loaded count
    state.allProductsLoaded += 1;
  },

  /**
	 * No longer deprecated as of Dec 11, 2017.
	 *
	 * When all of the cart items are loaded, this method is fired
	 * to keep track of how many cart items have loaded their data.
	 * When the count matches the number of cart items, we then
	 * retrieve the suggested items by way of
	 * the cart item's tags.
	 */
  [UPDATE_ITEM_LOADED_COUNT](state) {
    // update item loaded count
    state.allProductsLoaded += 1;
  },

  /*
	* Fired in response to the UPDATE_CART_QUANTITY action
	* once its promise is resolved. We only update
	* - subtotal
	* - totalProducts
	* - Individual Item Quantity
	*
	* We avoid changing the price, because we would have to make
	* another API call in order to retrieve it. Callback hell.
	*/
  [FETCH_REFRESHED_CART_DATA](state, { data }) {
    state.SubTotal = data.SubTotal;
    state.TotalProducts = data.TotalProducts;

    state.Items.forEach((item, index) => {
      const match = data.Items.find(product => {
        return product.Id == item.Id;
      });
      state.Items[index].Quantity = match.Quantity;
    });

    let tags = [];
    data.Items.forEach((item, index) => {
      tags = [...tags, ...item.Tags];
    });
    // console.log(tags);
    state.Tags = [...tags];

    const allIds = state.Items.map(item => item.ProductId);
    state.AllProductIds = [...allIds];
  },

  [UPDATE_AFTER_ADD_OR_DELETE](state, { data }) {
    state.SubTotal = data.SubTotal;
    state.TotalProducts = data.TotalProducts;

    state.Items = [...data.Items];

    let tags = [];
    data.Items.forEach((item, index) => {
      tags = [...tags, ...item.Tags];
    });
    state.Tags = [...tags];

    const allIds = state.Items.map(item => item.ProductId);
    state.AllProductIds = [...allIds];
  },

  /*
	* Deprecated.
	*
	* Gets an array of products with their pricing
	* information. Use case: the cart API doesn't include
	* pricing. However, we deprecate it because this info
	* is obtained when we hit the (slower) product API which
	* contains this data already.
	*
	* @param - array of objects.
	*/
  [UPDATE_ITEM_PRICE](state, { data }) {
    const products = data.Products;
    // console.log(products);

    state.Items.forEach((item, index) => {
      const match = products.find(product => {
        return product.ProductPrice.ProductVariantId == item.ProductVariantId;
      });
      state.Items[index].Price = match.ProductPrice.Price;
    });
  },

  /*
	* Deprecated.
	*
	* Called after the UPDATE_CART_QUANTITY action puts
	* the new quantity. Deprecated because the action now returns
	* a Promise, which when resolved calls the FETCH_REFRESHED_CART_DATA
	* action, and mutation.
	* @param payload - obj.  {itemId, quantity}
	*/
  [UPDATE_CART_QUANTITY](state, { payload }) {
    state.Items.forEach((item, index) => {
      if (item.Id == payload.itemId) {
        state.Items[index].Quantity = payload.quantity;
      }
    });

    // recalcutlate cart total number of items
    const newTotal = state.Items.reduce((accumulator, currentItem) => {
      return accumulator + currentItem.Quantity;
    }, 0);
    state.TotalProducts = newTotal;

    // recalcutlate cart total price
    const newSubtotal = state.Items.reduce((accumulator, currentItem) => {
      return accumulator + currentItem.Price * currentItem.Quantity;
    }, 0);

    const formatted = format(newSubtotal);
    state.SubTotal = formatted;
  },

  [FETCH_RELATED_CART_ITEMS](state, { payload, commonTags }) {
    // exclude items already in the cart
    const products = payload
      .filter(suggestedItem => {
        const inArray = state.Items.find(
          item => item.ProductId == suggestedItem.Id
        );
        return typeof inArray !== 'undefined' ? false : suggestedItem;
      })
      .slice(0, 3);

    state.CommonTags = [...commonTags];
    // here, we set the initial Price value to an empty string
    // so that the property exists right away. Otherwise, it
    // will not be reactive when it receives the values in
    // the function SET_SUGGESTED_PRODUCT_PRICES
    products.forEach((item, index) => {
      let variant = item.ProductVariants.find(v => v.Name == 'Acting Edition');
      variant =
        typeof variant !== 'undefined' ? variant : item.ProductVariants[0];
      products[index].Price = variant.Price;
      products[index].ProductVariantId = variant.Id;
      products[index].Edition = variant.Name;
    });

    // now, add it to the state.
    state.SuggestedProducts = [...products];

    // console.log(state.SuggestedProducts);
  },

  /*
	* Payload comes from the prices API - since the price doesn't
	* come with the search results data, we need to hit it again,
	* and append the price into each Suggested Product item.
	*/
  [SET_SUGGESTED_PRODUCT_PRICES](state, { payload }) {
    // console.log(payload.Products);
    // console.log(state.SuggestedProducts);

    state.SuggestedProducts.forEach((item, index) => {
      const match = payload.Products.find(prod => {
        return prod.ProductId == item.Id;
      });
      // console.log(match);
      state.SuggestedProducts[index].Price = match.ProductPrice.Price;
      state.SuggestedProducts[index].ProductVariantId =
        match.ProductPrice.ProductVariantId;
    });
  },

  /**
	 * probably not needed. The POST_CART_ITEM action returns a
	 * promise, which then triggers another action, retrieving
	 * the updated cart data, which then updates the state. This way
	 * we don't need this present method to update state manually,
	 * since we are getting it updated with real data.
	 */
  [POST_CART_ITEM](state, { payload }) {
    // console.log(payload);
  },

  [ADD_ITEM_NOTIFICATION](state, { payload }) {
    // console.log(payload);
  },

  [FETCH_ITEM_NOTIFICATIONS](state, { payload }) {
    // console.log(payload);
    state.Notifications = [...payload.Items];
  },
};

const cartStore = {
  state,
  getters,
  mutations,
  actions,
};

export default cartStore;



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/cart/store.js